import { apply, put, select } from 'redux-saga/effects';

import {
    errorNotification,
    loadNotificationCenterEntriesSuccessAction,
    loadNotificationCenterEntriesAction,
    successNotification,
} from '../reducers/notification.reducers';

export function* updateNotificationCenterEntryStates(notificationApi, { payload }) {
  try {
    const response = yield apply(
        notificationApi,
        notificationApi.updateNotificationEntries, [payload],
      );

    if (response.errorCode) {

    } else if (payload[0] && payload[0].state !== 'Seen') { yield put(loadNotificationCenterEntriesAction()); }
  } catch (e) {

  }
}


export function* loadNotificationCenterEntries(notificationApi) {
  try {
    const response = yield apply(
        notificationApi,
        notificationApi.loadNotificationEntries,
      );

    if (response.errorCode || !Array.isArray(response)) {
    } else {
      yield put(loadNotificationCenterEntriesSuccessAction(response));
    }
  } catch (e) {
  }
}




// WEBPACK FOOTER //
// ./src/app/sagas/notification.sagas.js